import type { api } from '~/libs/api';

type TripUtils = ReturnType<typeof api.useUtils>;

export const invalidateAccommodationQueries = (utils: TripUtils, tripId: string, itemId: number) =>
  Promise.all([
    utils.trip.getAlternativeRoomsForStayItem.invalidate({ journeyId: tripId, itemId, deduplicated: true }),
    utils.trip.getRoomsForStayItem.invalidate({ journeyId: tripId, itemId }),
    utils.trip.getAccommodation.invalidate({ tripId }),
    utils.trip.getOverview.invalidate({ tripId }),
    utils.trip.getPrice.invalidate({ tripId })
  ]);
